"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("./styles");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const SwappingMoneyBagsIcon = ({
  title,
  ...otherProps
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", { ...otherProps,
  width: "48",
  height: "50",
  viewBox: "0 0 48 50",
  xmlns: "http://www.w3.org/2000/svg",
  children: [title && /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    children: title
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
      transform: "translate(-23 -20)",
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
        transform: "translate(23 20)",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          fill: "#4CAA50",
          fillRule: "nonzero",
          d: "M37.72 45.553a.915.915 0 111.829.036.915.915 0 01-1.83-.036",
          className: "svg-fill-primary"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          stroke: "#4CAA50",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "1.8",
          d: "M26.502 5.59a22.866 22.866 0 017.857 2.972 23.04 23.04 0 016.142 5.436 23.067 23.067 0 013.867 7.268c.423 1.33.73 2.708.907 4.124",
          className: "svg-stroke-primary"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          stroke: "#ffffff",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "1.8",
          d: "M19.672 45.624a22.974 22.974 0 01-11.178-5.423 23.15 23.15 0 01-5.073-6.431 23 23 0 01-2.52-7.948",
          className: "svg-stroke-secondary"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          stroke: "#ffffff",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "1.8",
          d: "M17.1157 40.3871L20.5537 45.3781 15.5617 48.8161",
          className: "svg-stroke-secondary"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          stroke: "#4CAA50",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "1.8",
          d: "M29.0747 10.8276L25.6367 5.8366 30.6287 2.3986",
          className: "svg-stroke-primary"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          stroke: "#4CAA50",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "1.8",
          d: "M42.07 45.555c.789-.083 1.456-.237 2.01-.516 4.34-2.178 1.656-8.805-.642-11.51-1.591-1.873-3.521-3.447-4.88-3.447h-4.07c-1.357 0-3.183 1.481-4.67 3.262-2.263 2.711-4.567 9.39-.602 11.613 0 0 .655.614 5.718.606",
          className: "svg-stroke-primary"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          stroke: "#4CAA50",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "1.8",
          d: "M35.1431 30.0815L33.5391 24.3225 39.9151 25.8225 38.2541 30.0635z",
          className: "svg-stroke-primary"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          fill: "#4CAA50",
          fillRule: "nonzero",
          d: "M39.857 40.4l-.191-.345a.354.354 0 00-.502-.124c-.401.265-.777.4-1.12.402-.107 0-.321-.022-.726-.13-.842-.226-1.217-.166-1.608-.1a4.99 4.99 0 00.26-1.344l1.908-.011a.351.351 0 00.35-.355l-.002-.4a.353.353 0 00-.354-.35l-1.965.012a4.94 4.94 0 00-.15-.578c-.13-.42-.157-.633-.158-.738a.813.813 0 01.356-.706c.272-.201.655-.303 1.135-.306.365-.003.68.092.96.283.28.202.47.46.583.79a.352.352 0 00.49.203l.345-.17a.35.35 0 00.185-.407c-.144-.538-.467-.976-.96-1.3a2.799 2.799 0 00-1.63-.482c-.798.004-1.44.192-1.906.559-.485.387-.728.927-.724 1.606a.36.36 0 00.01.085l.298 1.168-.495.003a.351.351 0 00-.35.354l.002.4c0 .195.16.35.355.35l.59-.004c-.043.686-.228 1.27-.553 1.74a.35.35 0 00.042.45l.433.429a.352.352 0 00.436.048c.31-.197.718-.298 1.209-.301.108-.001.324.022.74.13.397.106.699.157.923.155.65-.004 1.22-.195 1.694-.568a.35.35 0 00.09-.447",
          className: "svg-fill-primary"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          stroke: "#ffffff",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "1.8",
          d: "M17.877 22.131c.789-.084 1.456-.237 2.01-.516 4.34-2.178 1.655-8.806-.643-11.51-1.59-1.874-3.52-3.447-4.878-3.447h-4.072c-1.357 0-3.183 1.481-4.67 3.262-2.262 2.711-4.566 9.39-.601 11.613 0 0 .655.614 5.718.606l7.136-.008z",
          className: "svg-stroke-secondary"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          stroke: "#ffffff",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "1.8",
          d: "M10.9517 6.6586L9.3477 2.4006 15.7237 0.8996 14.0627 6.6406z",
          className: "svg-stroke-secondary"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          fill: "#ffffff",
          fillRule: "nonzero",
          d: "M15.493 16.977l-.191-.347a.352.352 0 00-.503-.123c-.4.264-.776.4-1.118.402-.11 0-.322-.022-.727-.13-.842-.226-1.217-.166-1.608-.101.146-.423.234-.872.26-1.344l1.908-.01a.352.352 0 00.35-.355l-.002-.399a.353.353 0 00-.355-.351l-1.964.012a5.002 5.002 0 00-.15-.579c-.13-.419-.157-.633-.158-.737a.813.813 0 01.356-.706c.272-.201.655-.304 1.135-.307.365-.002.68.093.96.284.28.201.47.46.582.79a.36.36 0 00.2.213c.093.038.2.035.29-.01l.346-.171a.351.351 0 00.185-.407c-.144-.537-.467-.975-.96-1.3a2.808 2.808 0 00-1.63-.482c-.798.005-1.44.192-1.906.559-.485.388-.73.928-.724 1.606a.31.31 0 00.01.085l.298 1.169-.495.003a.352.352 0 00-.351.354l.003.4a.352.352 0 00.355.35l.59-.004c-.043.685-.228 1.269-.553 1.74a.351.351 0 00.042.451l.433.428a.348.348 0 00.436.047c.31-.196.718-.298 1.209-.301.108 0 .324.022.74.132.397.105.699.155.922.154.65-.004 1.222-.196 1.695-.568a.351.351 0 00.09-.447",
          className: "svg-fill-secondary"
        })]
      })
    })
  })]
});

SwappingMoneyBagsIcon.defaultProps = {
  title: undefined
};

var _default = (0, _styles.colourIcon)(SwappingMoneyBagsIcon);

exports.default = _default;